<script>
  export let type = "left";
</script>

<section class={"message " + (type === 'left' ? '-left' : '-right')}>
  <i class="nes-bcrikko"></i>
  <div class={"nes-balloon is-dark " + (type === 'left' ? 'from-left' : 'from-right')}>
    <slot></slot>
  </div>
</section>

<style>
  .nes-balloon {
      width: 100%;
  }
</style>